<template>
    <div class="userIndex">

        <div class="top" v-if="rolex!=1">
            <div class="imgBox">
                <img v-if="detail.companyLogo" style="width: 100%;height: 100%;" :src="getImg(detail.companyLogo)"/>
                <img v-else style="width: 100%;height: 100%;"
                     src="@/assets/home/user-qy-avatar.png"/>
            </div>
            <div class="rightBox">
                <div class="topBox">
                    <p class="name">{{ detail.companyName }}</p>
                    <div class="user-type">企业用户</div>
                </div>
                <div class="second">
                    <!--           <div class="address">地址：{{ detail.provject }}{{ detail.detailedAddress }}</div> -->
                    <div class="name"><img style="margin: 0 5px 3px 0;" src="../../../assets/home/user-phone.png"
                                           alt="">
                        {{ detail.linkman }}
                    </div>
                    <div class="name"><img style="margin: 0 5px 4px 0;" src="../../../assets/home/user-icon-05.png"
                                           alt="">{{ detail.phone }}
                    </div>
                </div>
            </div>
        </div>

        <div class="userIndex-top" v-else>
            <div class="imgBox">
                <a-image v-if="detail.headShot" :width="74" :height="103" :src="getImg(detail.headShot)"/>
                <img v-else style="width: 100%;height: 100%;"
                     src="@/assets/home/user-zj-avatar.png"/>

            </div>
            <div class="rightBox" style="display: flex;height: 100px;">
                <div style="width: 80%;margin-top: 20px">
                    <div class="topBox">
                        <p class="name">{{ detail.name }}
                            <img v-if="detail.appointmentFlag==='1'" :src="zjkcy" alt="" style="margin-bottom: 6px;"/>
                        </p>
                        <!--                        <div class="user-type">专家用户</div>-->
                    </div>
                    <a-divider dashed/>
                    <div class="second">
                        <!--                        <div style="margin-right: 50px"><span style="font-size: 14px;color: rgb(172, 172, 172)">注册用户：</span>专家用户</div>-->
                        <div>
                            <span style="font-size: 14px;color: #333333;">
                                <SolutionOutlined/>
                                专家
                            </span>
                            <a-divider type="vertical"/>
                            <span style="font-size: 14px;color: #333333;">
                                <PhoneOutlined/>
                                {{ detail.phoneNumber }}
                            </span>
                            <a-divider type="vertical" v-if="detail.appointmentFlag==='1'"/>
                            <span style="font-size: 14px;color: #333333;" v-if="detail.appointmentFlag==='1'">
                                <HourglassOutlined/>
                                聘书将于 <span style="color: orange">{{ moment(detail.appointmentTime).add(1, 'y').format("YYYY-M-D") }}</span> 到期
                            </span>
                        </div>
                    </div>

                </div>
                <div style="margin-right: 20px">
                    <img v-if="detail.auditState==='1' && detail.appointmentFlag==='1'" :src="rzcg" alt="">
                    <img v-else-if="detail.auditState==='1' && detail.appointmentFlag==='0'" :src="ysh" alt="">
                    <img v-else-if="detail.auditState==='0'" :src="dsh" alt="">
                    <img v-else :src="wrz" alt="">
                </div>
            </div>
        </div>

        <div class="userIndex-item" style="margin:20px 0;" v-if="rolex!=3">
            <user-index-title title="快捷操作" :imgURL="title1URL"/>
            <ul class="operate">
                <li v-for="item in rolex==1?operateList:operateList2" :key="item.id" @click="goJump(item)">
                    <img :src="item.imgURL" alt="">
                    <p>{{ item.title }}</p>
                </li>
            </ul>
        </div>

        <div class="userItem-item" style="margin-top:20px;" v-if="rolex==1">
            <user-index-title title="项目评审" :imgURL="title2URL"/>
            <!-- <div class="review">
                <div class="review-top">
                    <div class="review-top-item" v-for="item in columns" :key="item.id">{{ item.title }}</div>
                </div>
            </div> -->
            <a-card>
                <a-table :columns="columns" :pagination="pagination" :data-source="dataSource" :loading="loading"
                         @change="onTableChange">
                    <template #projectReviewName="{ record, text }">
                        <a href="#" @click="showDetail(record)">{{ text }}</a>
                    </template>
                    <template #meetingMinutes="{ record }">
                        <FileUpload v-model:value="record.meetingMinutes" :show-btn="false" disabled></FileUpload>
                    </template>
                    <template #applicationAttachment="{ record }">
                        <FileUpload v-model:value="record.applicationAttachment" :show-btn="false"
                                    disabled></FileUpload>
                    </template>
                    <template #reviewStatus="{ record, text }">
                        <div style="cursor: pointer" @click="showProcessPanel(record)">
                            <a-tag v-if="text===2" style="background-color: #b7cef2; color: #0042FF;border:none">
                                待确认
                            </a-tag>
                            <a-tag v-if="text===0" style="background-color: #ffeee5; color: #FF5500;border:none">驳回
                            </a-tag>
                            <a-tag v-if="text===1" style="background-color: #e5f2e5; color: #008000;border:none">通过
                            </a-tag>
                            <a-tag v-if="text==='-1'" style="background-color: #fcfcfc; color: #999999;border:none">
                                已作废
                            </a-tag>
                        </div>
                    </template>
                    <template #action="{ record }">
                        <div class="table-row-operations">
                            <a v-if="record.auditResult===2" @click="onConfirm(record)">确认</a>
                            <!-- <a v-if="record.auditResult===1||record.auditResult=='-1'"
                               @click="onConfirm(record)">下载资料</a> -->
                        </div>
                    </template>
                </a-table>

                <ConfirmModal ref="confirm" @finish="loadData"></ConfirmModal>
                <Detail ref="detail"></Detail>
                <ProcessPanel ref="panel"></ProcessPanel>
            </a-card>


        </div>


        <user-index-title title="基本信息" :imgURL="title2URL" v-if="rolex!=1"/>

        <div class="info-content" v-if="rolex!=1">
            <div class="title">
                <div class="tit">企业信息</div>
                <div class="btn" @click="onEdit">
                    <img src="../../../assets/home/user-icon-01.png" alt="">
                    编辑
                </div>
            </div>
            <div class="content">
                <div class="left">
                    <div class="item">
                        <div class="name">邮政编码：</div>
                        <div class="value">
                            {{ detail.postalCode }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">统一社会信用代码：</div>
                        <div class="value">
                            {{ detail.oraganizationCode }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">企业法人：</div>
                        <div class="value">
                            {{ detail.corporation }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">法人电话：</div>
                        <div class="value">
                            {{ detail.contactsMobile }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">地址：</div>
                        <div class="value">
                            {{ detail.provject }}{{ detail.detailedAddress }}
                        </div>
                    </div>
                </div>
                <div class="middle">
                    <div class="item">
                        <div class="name">注册时间（企业成立时间）：</div>
                        <div class="value">
                            {{ detail.registerTime?.substr(0, 10) }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">企业性质：</div>
                        <div class="value">
                            <dict-render :dict-obj="dictObjs['businessScope']" v-if="detail.businessScope"
                                         :text="detail.businessScope"></dict-render>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">联系人：</div>
                        <div class="value">
                            {{ detail.linkman }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">联系电话：</div>
                        <div class="value">
                            {{ detail.phone }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">营业执照(PDF格式)：</div>
                        <div class="value">
                            <file-upload v-model:value="detail.licenceFile" :showBtn="false" disabled/>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="item">
                        <div class="name">注册资本：</div>
                        <div class="value">
                            {{ detail.registerMoney }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">所属园区：</div>
                        <div class="value">
                            {{ detail.baseName }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">所属领域：</div>
                        <div class="value">
                            <dict-render :dict-obj="dictObjs['corpbelong_type']" v-if="detail.companyDomain"
                                         :text="detail.companyDomain"></dict-render>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">企业邮箱：</div>
                        <div class="value">
                            {{ detail.comEmail }}
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">企业法人身份证：</div>
                        <div class="value">
                            <file-upload v-model:value="detail.legalPersonCard" :showBtn="false" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getCorpInfo"/>
        </div>

        <UserModal2 ref="userModal2" :form-primary-key-field="listKeyField" @finish="getExpertInfo"/>

    </div>
</template>

<script>
import moment from "moment";
import {expert} from "@/api/projectReviewService";
import {file_service, sys_admin} from "@/api/adminService";
import {SolutionOutlined, HourglassOutlined, PhoneOutlined} from '@ant-design/icons-vue';
import UserIndexTitle from './components/UserIndexTitle.vue';
import {dictMixin, tableListMixin} from "@/mixins";
import {application} from "@/api/projectReviewService";
import ConfirmModal from "../expert/resultAudit/components/ConfirmModal";
import Detail from "@/views/sys/expert/registered/components/Detail";
import ProcessPanel from "@/views/sys/application/resultAudit/components/ProcessPanel";


import UserModal from '../company/companyInfo/components/UserModal';
import UserModal2 from './components/UserModal.vue';
import {companyInfo} from "@/api/companyService";
import {showCity} from "@/utils/util";
import DictRender from "@/components/other/DictRender";
import {sys_policy} from "@/api/policyService";


const zjkcy = require('@/assets/img/zjkcy.png')
const rzcg = require('@/assets/img/rztg.png')

const ysh = require('@/assets/img/expert-state/已审核.png')
const dsh = require('@/assets/img/expert-state/待审核.png')
const wrz = require('@/assets/img/expert-state/未认证.png')

const sfz = require('@/assets/home/user-icon-02.png')
const sqb = require('@/assets/home/user-icon-03.png')
const zczs = require('@/assets/home/user-icon-04.png')
const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {
        title: "项目名称",
        dataIndex: "applicationName",
        key: "applicationName",
        ellipsis: true,
        slots: {customRender: "projectReviewName"}
    },
    {title: "评审时间", width: "200px", dataIndex: "reviewTime", key: "reviewTime"},
    {
        title: "审评状态",
        width: "150px",
        dataIndex: "auditResult",
        key: "auditResult",
        slots: {customRender: "reviewStatus"}
    },
    {title: "操作", width: "150px", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    components: {
        SolutionOutlined,
        HourglassOutlined,
        PhoneOutlined,
        UserIndexTitle,
        ConfirmModal,
        Detail,
        ProcessPanel,
        UserModal,
        DictRender,
        UserModal2
    },
    mixins: [tableListMixin, dictMixin],
    data() {
        return {
            moment,
            zjkcy,
            rzcg,
            sfz,
            sqb,
            zczs,
            ysh,
            dsh,
            wrz,
            detail: {},
            operateList: [
                {
                    id: 1,
                    title: '专家认证',
                    imgURL: require('../../../assets/img/operate1.png'),
                    routerLink: '/sys/expertAudit'
                },
                {
                    id: 1,
                    title: '银行账户管理',
                    imgURL: require('../../../assets/img/operate2.png'),
                    routerLink: 'pop-up'
                },
                {
                    id: 1,
                    title: '项目评审报名',
                    imgURL: require('../../../assets/img/operate3.png'),
                    routerLink: '/projectReview'
                },
            ],
            operateList2: [
                {
                    id: 1,
                    title: '企业积分制',
                    imgURL: require('../../../assets/img/operate4.png'),
                    routerLink: '/sys/manage'
                },
                {
                    id: 2,
                    title: '金融要求',
                    imgURL: require('../../../assets/img/operate5.png'),
                    routerLink: '/sys/financedemand'
                },
                {
                    id: 3,
                    title: '惠企政策',
                    imgURL: require('../../../assets/img/operate6.png'),
                    routerLink: '/sys/policyPublicData'
                },
                {
                    id: 4,
                    title: '资金追踪',
                    imgURL: require('../../../assets/img/operate7.png'),
                    routerLink: '/sys/fundsTracking'
                },
                {
                    id: 5,
                    title: '政策兑现',
                    imgURL: require('../../../assets/img/operate8.png'),
                    routerLink: '/materializePolicy/Add'
                },
            ],
            title1URL: require('../../../assets/img/userIndex-icon1.png'),
            title2URL: require('../../../assets/img/userIndex-icon2.png'),
            columns,
            listUrl: application.myAppendAudit,
            listKeyField: "id",
            dictNames: 'businessScope,corpbelong_type,affiliated_park',
            rolex: 0
        }
    },
    created() {
        this.getAction({
            url: sys_admin.userInfor
        }).then(res => {
            let str = JSON.parse(res.roleName)[0]
            console.log(str, '专家')
            if (str == '专家') {
                this.rolex = 1

            } else if (str == '企业用户') {
                this.rolex = 2

            } else {
                this.rolex = 3
            }

            this.roleMethod()
        })

    },
    mounted() {
    },
    methods: {
        roleMethod() {
            if (this.rolex == 1) {
                this.getExpertInfo()
            } else {
                this.getCorpInfo()
                this.getTwoCode()
            }
        },
        getCorpInfo() {
            this.getAction({
                url: companyInfo.detail
            }).then(res => {
                if(res.companyName){
                    this.$ls.set('userName', res.companyName, 1000 * 60 * 60 * 5)
                }
                
                this.detail = {
                    ...res,
                    provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''
                }
            })
        },
        goJump(data) {
            if (data.routerLink == 'pop-up') {
                console.log(this.detail);
                this.onShowModal('userModal2', this.detail);
            } else {
                this.$router.push(data.routerLink)
            }
        },
        getExpertInfo() {
            console.log(expert, 182);
            this.getAction({
                url: expert.current
            }).then(res => {
                console.log(184, res);
                this.detail = {...res}
            })
        },
        getImg(imgUrl) {
            console.log(imgUrl, 358);
            return file_service.imagesWeb(imgUrl)
        },


        onReset() {
            this.dateTime = []
            this.$refs.searchForm.resetFields();
            this.queryParam = {};
            this.searchForm = {}
            this.loadData(1);
        },
        changeTime(time) {
            this.queryParam.startTime = time[0]
            this.queryParam.endTime = time[1]
        },
        showProcessPanel(row) {
            if (row.reviewStatus === '-1') {
                return
            }
            let data = {...row}
            // console.log(data,"aaaaaaaaaa")
            const refEle = this.$refs['panel'];
            refEle.reviewId = data.applicationId
            refEle.reviewStatus = data.reviewStatus
            refEle.visible = true
        },
        showDetail(row) {
            console.log(row.applicationId)
            this.getAction({
                url: application.detail,
                params: {
                    id: row.applicationId
                }
            }).then(resp => {
                this.onShowModal("detail", resp)
            })
        },
        onConfirm(record) {
            const refEle = this.$refs["confirm"];
            refEle.form = {
                batch: record.batch,
                applicationId: record.applicationId,
                id: record.id,
                fileStr: record.appendFiles
            };
            refEle.visible = true;
        },

        getTwoCode() {
            this.getAction({
                url: sys_policy.getErCode
            }).then(res => {
                this.$ls.set('erweimaCode', res);
                // this.erweimaCode = res
            })
        },
        onEdit() {
            this.onShowModal('userModal', this.detail);
        },
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            console.log(refEle, refName);
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },

    },
}
</script>

<style scoped lang="less">
.userIndex {
    height: 100%;
    // background-color:pink;
    .userIndex-top {
        margin-bottom: 20px;
        display: flex;
        background: #fff;
        padding: 30px;

        .imgBox {
            float: left;
            margin-right: 20px;
            width: 74px;
            height: 103px;
        }

        .rightBox {
            color: #333;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .topBox {
                //overflow: hidden;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .name {
                    float: left;
                    font-weight: 700;
                    font-size: 22px;
                }

                .user-type {
                    // background: url("../../../../assets/home/user-type.png");
                    background-size: 100% 100%;
                    width: 100px;
                    height: 30px;
                    text-align: center;
                    color: #fff;
                    line-height: 30px;
                    padding-left: 18px;
                    margin-left: 8px;
                }

                .nameRight {
                    float: left;
                    margin-left: 25px;
                    margin-top: 10px;
                }
            }

            .second {
                font-size: 16px;
                margin-top: 10px;
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                align-items: center;

                .name {
                    width: 50%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }
            }
        }
    }


    .userIndex-item {
        .operate {

            display: flex;

            li {
                margin-right: 20px;
                position: relative;
                width: 180px;
                height: 80px;
                box-sizing: border-box;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                }

                p {
                    position: absolute;
                    top: 50%;
                    left: 20px;
                    font-weight: bold;
                    font-size: 18px;
                    color: #FFFFFF;
                    transform: translateY(-50%);
                }
            }
        }


    }

    .review {
        padding: 20px;
        background-color: #fff;
        box-sizing: border-box;

        .review-top {
            padding: 0 0 0 20px;
            display: flex;
            background-color: #f3f4f9;
            line-height: 50px;
            box-sizing: border-box;
        }
    }

    .top {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        background: #fff;
        padding: 30px;

        .imgBox {
            float: left;
            margin-right: 20px;
            width: 140px;
            height: 120px;
        }

        .rightBox {
            color: #333;
            width: 100%;

            .topBox {
                display: flex;
                align-items: center;

                .name {
                    float: left;
                    font-weight: 700;
                    font-size: 22px;
                }

                .user-type {
                    background: url("../../../assets/home/user-type-01.png");
                    background-size: 100% 100%;
                    width: 100px;
                    height: 30px;
                    text-align: center;
                    color: #fff;
                    line-height: 30px;
                    padding-left: 18px;
                    margin-left: 8px;
                }

                .nameRight {
                    float: left;
                    margin-left: 25px;
                    margin-top: 10px;
                }
            }

            .second {
                font-size: 16px;
                margin-top: 10px;
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                align-items: center;

                .name {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    -o-text-overflow: ellipsis;
                }

                .name:first-child {
                    padding-right: 20px;
                    position: relative;

                    &::after {
                        content: '';
                        display: block;
                        width: 1px;
                        height: 15px;
                        background: #ccc;
                        position: absolute;
                        top: 5px;
                        right: 0;
                    }
                }

                .name:last-child {
                    padding-left: 20px;
                }
            }
        }
    }

}


.info-content {
    background: #fff;

    .content {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;

        .left, .middle, .right {
            width: 30%;
        }

        .left, .middle {
            border-right: 1px solid #F5F5F5;
        }

        .item {
            margin: 0 0 20px 0;

            .name {
                font-size: 14px;
                color: #999999;
                margin-bottom: 6px;
            }

            .value {
                font-size: 14px;
                color: #333333;

                a {
                    color: #0059B5;
                }

                img {
                    width: 16px;
                }
            }
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        border-bottom: 1px solid #DEDEDE;

        .btn {
            color: #999999;
            font-size: 14px;
            cursor: pointer;

            img {
                width: 15px;
                height: 15px;
                margin-bottom: 3px;
            }
        }

        .tit {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            padding-left: 10px;
            position: relative;

            &::before {
                content: '';
                display: block;
                width: 4px;
                height: 14px;
                background: #0059B5;
                border-radius: 2px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
    }
}

/deep/ .ant-pagination {
    display: none !important;
}
:deep(.ant-divider-horizontal){
    margin: 5px 0;
}
:deep(.ant-divider-dashed){
    border-width: 2px 0 0;
}
:deep(.ant-divider-vertical){
    border-left: 2px solid rgba(0, 0, 0, 0.06);
}
</style>
